import LandingShell from '@/components/landing/LandingShell';
import SEO from '@/components/common/SEO';
import SemanticFooter from '@/components/semantic/SemanticFooter';
import SemanticPageLayout from '@/components/semantic/SemanticPageLayout';
import { getBreadcrumbItems } from '@/lib/semantic-content/breadcrumbs';
import { buildSemanticStructuredData } from '@/lib/semantic-content/schema';

import { resolveSemanticLinks } from '@/lib/semantic-content/pages';
import type { SemanticPage } from '@/lib/semantic-content/types';

type AppScreenshot = {
  id?: string;
  label?: string;
  imageUrl: string;
};

export default function SemanticPageDocument({
  page,
  screenshots = [],
}: {
  page: SemanticPage;
  screenshots?: AppScreenshot[];
}) {
  return (
    <LandingShell>
      <SEO
        title={page.title}
        description={page.description}
        ogTitle={page.ogTitle}
        ogDescription={page.ogDescription}
        url={page.path}
        type="article"
        structuredData={buildSemanticStructuredData(page)}

      />
      <SemanticPageLayout
        page={page}
        breadcrumbItems={getBreadcrumbItems(page)}
        quickLinks={resolveSemanticLinks(page.quickLinkPaths)}
        relatedLinks={resolveSemanticLinks(page.relatedLinkPaths)}
        screenshots={screenshots}
      />
      <SemanticFooter />
    </LandingShell>
  );
}